import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pos-layout',
  template: `
  <div style="max-height: 100vh; overflow-y: hidden">
  <header>
    <pos-navegacao></pos-navegacao>
  </header>
  <main>
    <router-outlet></router-outlet>
  </main>
</div>

  `
})
export class PosLayoutComponent implements OnInit {
  ngOnInit() {
  }

}
